import React from "react";
import "../styles/services.css";
import Footer from "./Footer";

import img1 from "../assets/last 1.jpg";
import img2 from "../assets/last 2.jpg";
import img3 from "../assets/last 3.jpg";
import img4 from "../assets/last 4.jpg";
import img5 from "../assets/last 5.jpg";
import img6 from "../assets/last 6.jpg";
import img7 from "../assets/last 7.jpg";
import img8 from "../assets/last 8.jpg";
import img9 from "../assets/last 9.jpg";
import img10 from "../assets/last 10.jpg";
import img11 from "../assets/last 11.jpg";

function ServicesPage() {
  return (
    <>
      <section className="services">
        <h2 className="services-title">Services</h2>
        <p className="services-intro">
          We provide a variety of services to help people keep their freedom
          while developing their ability to perform personal household tasks
          autonomously. There is always something that needs to be done, so
          knowing that you can obtain assistance with these tasks while
          maintaining your freedom is reassuring. We provide high-quality
          support coordination and core support services.
        </p>

        {/* === Personal Care === */}
        <div className="service-block ">
          <div className="service-text">
            <h3 className="service-heading"> Personal Care</h3>
            <p>We provide ongoing support with daily tasks.</p>
            <ul>
              <li>Showering</li>
              <li>Selection of clothes</li>
              <li>Dressing and grooming</li>
            </ul>
          </div>
          <img src={img11} alt="Personal Care" className="service-img" />
        </div>

        {/* === Social Inclusion === */}
        <div className="service-block reversex">
          <img src={img10} alt="Social Inclusion" className="service-img" />
          <div className="service-text">
            <h3 className="service-heading">Social Inclusion and Transport</h3>
            <p>
              Transport and social inclusion assistance by coordinating trips to
              outings, shops, medical appointments and events.
            </p>
          </div>
        </div>

        {/* === Community Access === */}
        <div className="service-block ">
          <div className="service-text">
            <h3 className="service-heading"> Community Access</h3>
            <p>
              One-on-one support for community engagement, including activities
              like:
            </p>
            <div className="two-column-list">
              <ul>
                <li>Grocery Shopping</li>
                <li>Medical Appointments</li>
                <li>Accessing the Library</li>
                <li>Bank/Post Office</li>
                <li>YMCA or Pool</li>
                <li>Using the GYM</li>
                <li>Visiting Friends</li>
              </ul>
              <ul>
                <li>Going to a Cafe</li>
                <li>Watch Sports Events</li>
                <li>Group Activities</li>
                <li>Beauty Appointments</li>
                <li>Walk or Drive</li>
                <li>Community Events</li>
              </ul>
            </div>
          </div>
          <img src={img9} alt="Community Access" className="service-img" />
        </div>

        {/* === Group Activities === */}
        <div className="service-block reversex">
          <img src={img8} alt="Group Activities" className="service-img" />
          <div className="service-text">
            <h3 className="service-heading"> Group/Centre Activities</h3>
            <p>We provide half/full-day programs for:</p>
            <ul>
              <li>Art and Craft Room</li>
              <li>Computer Room</li>
              <li>TV and Movie Room</li>
              <li>Library and Quiet Room</li>
              <li>Board Games</li>
              <li>Activity Room</li>
              <li>Lunch Spaces</li>
            </ul>
          </div>
        </div>

        {/* === Domestic Assistance === */}
        <div className="service-block ">
          <div className="service-text">
            <h3 className="service-heading"> Personal Domestic Assistance</h3>
            <p>We support with domestic duties:</p>
            <ul>
              <li>Dusting</li>
              <li>Vacuuming</li>
              <li>Cleaning kitchen/bathrooms</li>
              <li>Washing</li>
              <li>Ironing</li>
              <li>Changing bedsheets</li>
            </ul>
          </div>
          <img src={img7} alt="Domestic Assistance" className="service-img" />
        </div>

        {/* === Meal Preparation === */}
        <div className="service-block reversex">
          <img src={img6} alt="Meal Preparation" className="service-img" />
          <div className="service-text">
            <h3 className="service-heading"> Meal Preparation</h3>
            <p>
              Support with grocery shopping and food preparation, including
              special dietary needs.
            </p>
          </div>
        </div>

        {/* === Gardening === */}
        <div className="service-block">
          <div className="service-text">
            <h3 className="service-heading"> Home and Garden Maintenance</h3>
            <p>We help with:</p>
            <ul>
              <li>Mowing</li>
              <li>Weeding</li>
              <li>Garden Waste Removal</li>
            </ul>
          </div>
          <img src={img5} alt="Garden Maintenance" className="service-img" />
        </div>

        {/* === Short Term Accommodation === */}
        <div className="service-block reversex">
          <img
            src={img4}
            alt="Short Term Accommodation"
            className="service-img"
          />
          <div className="service-text">
            <h3 className="service-heading"> Short Term Accommodation</h3>
            <p>
              Improve living standards with excellent facilities and a
              supportive care environment to promote independence.
            </p>
          </div>
        </div>

        {/* === Support Coordination === */}
        <div className="service-block">
          <div className="service-text">
            <h3 className="service-heading"> Support Coordination</h3>
            <p>
              Help participants understand NDIS, manage their support, and
              navigate their plan from start to finish.
            </p>
          </div>
          <img src={img3} alt="Support Coordination" className="service-img" />
        </div>

        {/* === Recovery Coaching === */}
        <div className="service-block reversex">
          <img src={img2} alt="Recovery Coaching" className="service-img" />
          <div className="service-text">
            <h3 className="service-heading">Psychosocial Recovery Coaching</h3>
            <p>
              Coaches help participants make sense of their NDIS plan, set
              goals, and guide their recovery journey with mentoring.
            </p>
          </div>
        </div>

        {/* === Employment Access === */}
        <div className="service-block">
          <div className="service-text">
            <h3 className="service-heading">
              Access Assist / Maintain Employment
            </h3>
            <p>
              Support participants in discovering and navigating jobs by
              developing their abilities and planning their future.
            </p>
          </div>
          <img src={img1} alt="Employment" className="service-img" />
        </div>
      </section>

      <Footer />
    </>
  );
}

export default ServicesPage;
